import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BackHistory } from '@components/listing/Breadcrumb';
import EditorialHero from '../hero/EditorialHero';
import customEventBus from '@common/scripts/libs/eventBus';
const PlpHero = (props) => {
    var _a, _b, _c;
    const { category, inSearch } = useSelector((state) => state.search);
    const { t } = useTranslation();
    const [hideHero, setHideHero] = useState(true);
    const firstRender = useRef(true);
    useEffect(() => {
        let __hidehero = false;
        if (!category || inSearch || !category.imageMobile || !category.imageDesktop) {
            __hidehero = true;
        }
        else if (firstRender.current) {
            const header = document.getElementsByTagName('header')[0];
            header.dataset.color = 'white';
            header.dataset.transparent = 'true';
            customEventBus.emit('header:settrasparency', {
                transparent: 'true',
                color: 'white',
            });
        }
        setHideHero(__hidehero);
        firstRender.current = false;
    }, [category, inSearch]);
    const plpBack = ((_a = document.referrer) === null || _a === void 0 ? void 0 : _a.indexOf(location.origin)) > -1 && React.createElement(BackHistory, { className: "font__title", staticLabel: t('label.back'), inverted: true });
    return (React.createElement(EditorialHero, { title: category.plpName || category.name, backComponent: plpBack, hideHero: hideHero, description: category.description, descriptionReadMore: category.descriptionReadMore, rightText: category.season, imageMobile: (_b = category.imageMobile) === null || _b === void 0 ? void 0 : _b.url, imageDesktop: (_c = category.imageDesktop) === null || _c === void 0 ? void 0 : _c.url }));
};
export default PlpHero;
